import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.machine');
import { OnInit, Input, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-farm-machine',
template: templateSource || '',
    styles: [``],
})
export class PortalFarmMachineComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    @Input() farm_id!: string;
    @Input() farm!: any;

    public machines: any[] = [];
    public role: string | null = null;

    public machine: any = {
        data: {
            meta: {
                remote_mode: 'default',
            },
        },
        form: {},
        status: {
            loading: false,
            pending_mode: null,
        },
        select: null as any,
        event: {} as any,
    };

    constructor(@Inject( Service)         public service: Service,    ) {}

    private async showModal(message: string): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    public async ngOnInit() {

        await this.service.init();

        await this.service.auth.allow();
        this.role = this.service.auth.session?.role || null;

        this.machine.select = (item: any) => this.selectMachine(item);
        this.machine.event = {
            remote_wash: () => this.toggleRemote('wash', '세척'),
            remote_dry: () => this.toggleRemote('dry', '건조'),
            remote_work: () => this.toggleRemote('work', '선별'),
        };

        await this.loadMachines();

        if (this.machines.length > 0) {
            await this.selectMachine(this.machines[0]);
        }

        await this.service.render();
    }

    private async loadMachines() {

        const res = await wiz.call('machines', {
            farm_id: this.farm_id,
        });

        if (res?.code === 200 && Array.isArray(res.data)) {
            this.machines = res.data.map((m: any) => {

                try {
                    m.meta = m.meta ? JSON.parse(m.meta) : {};
                } catch (e: any) {
                    m.meta = {};
                }

                if (!m.meta.remote_mode) {
                    m.meta.remote_mode = 'default';
                }

                try {
                    m.machine_condition = JSON.parse(m.machine_condition);
                } catch (e: any) {
                    m.machine_condition = [];
                }

                try {
                    m.tray = JSON.parse(m.tray);
                } catch (e: any) {
                    m.tray = [];
                }

                if (m.installed) {
                    m.installed = moment(m.installed).format('YYYY-MM-DD');
                } else {
                    m.installed = '';
                }

                return m;
            });
        } else {
            this.machines = [];
        }

    }

    public async selectMachine(item: any) {
        if (!item) return;

        this.machine.data = item;
    }

    private async toggleRemote(mode: string, label: string) {
        if (!this.machine.data?.id) return;

        this.machine.status.loading = true;
        this.machine.status.pending_mode = mode;
        await this.service.render();

        const currentMode = this.machine.data.meta?.remote_mode;
        const newMode = currentMode === mode ? 'default' : mode;

        try {
            const res = await wiz.call('remote', {
                machine_id: this.machine.data.id,
                mode: newMode,
            });

            if (res?.code === 200) {
                this.machine.data.meta.remote_mode = newMode;

                if (newMode === 'default') {
                    await this.showModal(`${label}운전이 비활성화 되었습니다.`);
                } else {
                    await this.showModal(`${label}운전이 활성화 되었습니다.`);
                }
            } else {
                await this.showModal('원격 제어에 실패했습니다.');
            }
        } catch (e) {
            console.error('remote error:', e);
            await this.showModal('원격 제어 중 오류가 발생했습니다.');
        } finally {
            this.machine.status.loading = false;
            this.machine.status.pending_mode = null;
            await this.service.render();
        }
    }

    public async regist(success_msg?: string) {

        const data = JSON.parse(JSON.stringify(this.machine.data));
        data.farm_id = this.farm_id;

        if (!data.farm_id) {
            await this.showModal('농장 정보가 입력되지 않았습니다.');
            return;
        }

        if (!data.id) {
            await this.showModal('선별기 일련번호가 입력되지 않았습니다.');
            return;
        }

        if (!data.model) {
            await this.showModal('선별기 모델 정보가 입력되지 않았습니다.');
            return;
        }

        data.installed = moment(data.installed).format('YYYY-MM-DD HH:mm:ss');

        try {
            data.meta = JSON.stringify(data.meta);
        } catch (e: any) {
            data.meta = '{}';
        }

        try {
            data.machine_condition = JSON.stringify(data.machine_condition);
        } catch (e: any) {
            data.machine_condition = '[]';
        }

        try {
            data.tray = JSON.stringify(data.tray);
        } catch (e: any) {
            data.tray = '[]';
        }

        const res = await wiz.call('update', data);

        if (res?.code === 200) {
            await this.showModal(success_msg || '선별기 정보가 등록되었습니다.');
        } else {
            await this.showModal('선별기 등록에 실패했습니다. 정보를 확인해주세요.');
        }

    }

    public async onStatusChange(status: string) {
        this.machine.data.status = status;
        await this.service.render();
    }

    public src(item: string) {
        return `/assets/images/png/${item}`;
    }

    public async rerender() {
        await this.service.render();
    }

    public async removeTray(item: any) {
        const idx = this.machine.data.tray.indexOf(item);
        if (idx >= 0) {
            this.machine.data.tray.splice(idx, 1);
        }
        await this.service.render();
    }

    public async addTray(item: any) {
        this.machine.data.tray.push(item);
        await this.service.render();
    }

    public async moveCondition(from: number, to: number) {
        const arr = this.machine.data.machine_condition;
        if (!arr) return;
        if (to < 0 || to >= arr.length) return;

        const item = arr.splice(from, 1)[0];
        arr.splice(to, 0, item);

        await this.service.render();
    }

}

export default PortalFarmMachineComponent;